import { useEffect, useState } from "react";

export const useCountdown = (startDate, endDate) => {
  const now = new Date();
  const start = getUTCDate(startDate);
  const end = getUTCDate(endDate);
  const countDownDate = endDate ? end.getTime() : 0;
  const initialCountDown = endDate ? countDownDate - now.getTime() : 0;

  const [countDown, setCountDown] = useState(null);
  useEffect(() => {
    if (!startDate && !endDate) return;
    if (now < start || now > end) return;
    setCountDown(initialCountDown);
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return now < start || now > end ? null : getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
  if (!countDown) return;
  const hours = Math.floor(countDown / (1000 * 60 * 60));
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return getStringTime([hours, minutes, seconds]);
};

const getStringTime = (hms) => {
  const strTime = hms.map((number) => {
    return number < 10 ? `0${number}` : `${number}`;
  });
  const day = parseInt((strTime[0] / 24).toString());
  const hour = strTime[0] % 24 < 10 ? "0" + (strTime[0] % 24) : strTime[0] % 24;
  const min = strTime[1];
  const sec = strTime[2];
  return { day: day, hour: hour, min: min, sec: sec };
};

export const getUTCDate = (strDate: string) => {
  const d = new Date(strDate);
  const year = d.getUTCFullYear();
  const month = d.getUTCMonth();
  const date = d.getUTCDate();
  const hours = d.getUTCHours();
  const minutes = d.getUTCMinutes();
  const seconds = d.getUTCSeconds();

  return new Date(year, month, date, hours, minutes, seconds);
};

export const useTimeCountdown = (startDate, endDate) => {
  const now = new Date();
  const start = startDate;
  const end = endDate;
  const countDownDate = endDate ? end.getTime() : 0;
  const initialCountDown = endDate ? countDownDate - now.getTime() : 0;

  const [countDown, setCountDown] = useState(null);
  useEffect(() => {
    if (!startDate && !endDate) return;
    if (now < start || now > end) return;
    setCountDown(initialCountDown);
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return now < start || now > end ? null : getReturnValues(countDown);
};
